import * as React from 'react';
import cx from 'classnames';
import { AuthenticateChannel } from '../../../core/types';
import styles from './style.scss';

export type ConnectWithButtonLayout = 'text_button' | 'icon_button';

export type ConnectWithButtonProps = {
  channel: AuthenticateChannel;
  label?: string;
  icon?: React.ReactNode;
  layout?: ConnectWithButtonLayout;
  className?: string;
  iconClassName?: string;
  labelClassName?: string;
  disabled?: boolean;
  onClick?: () => void;
};

export default function ConnectWithButton({
  channel: _channel,
  label,
  icon,
  layout = 'text_button',
  className,
  iconClassName,
  labelClassName,
  disabled,
  onClick,
}: ConnectWithButtonProps) {
  const isIconButtonLayout = layout === 'icon_button';

  const buttonClassName = cx(
    styles.container,
    isIconButtonLayout ? styles.iconButton : styles.textButton,
    disabled
      ? isIconButtonLayout
        ? styles.iconButtonDisabled
        : styles.textButtonDisabled
      : undefined,
    className
  );

  return (
    <div className={buttonClassName} onClick={onClick}>
      {icon && <div className={cx(styles.icon, iconClassName)}>{icon}</div>}
      {!isIconButtonLayout && (
        <div className={cx(styles.label, labelClassName)}>{label}</div>
      )}
    </div>
  );
}
